import { QueryFunctionContext } from "@tanstack/react-query";
import { axiosClientCMS } from "../../api/apiClient";

export interface JobOffersInput {
  locale: string;
}

export type JobOfferItem = {
  id: number;
  attributes: {
    title: string;
    requirements: string;
    advantages: string;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    locale: string;
  };
};

export type JobOfferResponse = {
  meta: any;
  data: JobOfferItem[];
};

export const fetchJobOffers = async ({
  queryKey,
}: QueryFunctionContext<[string, JobOffersInput]>): Promise<JobOfferResponse> => {
  const [, { ...params }] = queryKey;
  return axiosClientCMS.get("/job-offers", { params }).then((data) => data.data);
};
